import { http } from '../axios';
import { AggregationResponseOut } from '../../store/api';
import { shopPrefix } from '../../config';
import { FetchAggregationsOptions } from '../listContent/fetchAggregations';

type Options = FetchAggregationsOptions & {
    readonly scope: string;
    readonly query?: string;
    readonly refine: string | null;
};

const url = `${shopPrefix}/v2/collection/complete/search/aggregation/:scope`;

export const fetchCollectionSearchAggregations = (options: Options): Promise<AggregationResponseOut> => {
    return http
        .post<AggregationResponseOut>(url, options.filters, {
            signal: options.signal,
            pathParams: {
                scope: options.scope
            },
            params: {
                q: options.query,
                refine: options.refine
            }
        })
        .then(response => response.data);
};
